import { render, staticRenderFns } from "./ChatBotConfig.vue?vue&type=template&id=3261e1d6&"
import script from "./ChatBotConfig.vue?vue&type=script&lang=js&"
export * from "./ChatBotConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports